"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promptDef = void 0;
exports.handle = handle;
const context_1 = require("../resources/context");
exports.promptDef = {
    name: 'continue-thread',
    description: 'Load full thread context (idea, design, active plan, refs) and return a next-action proposal prompt.',
    arguments: [
        { name: 'weaveId', description: 'Weave ID', required: true },
        { name: 'threadId', description: 'Thread ID', required: true },
    ],
};
async function handle(root, args) {
    const weaveId = args['weaveId'];
    const threadId = args['threadId'];
    if (!weaveId || !threadId)
        throw new Error('weaveId and threadId are required');
    const ctx = await (0, context_1.handleContextResource)(root, `loom://context/thread/${weaveId}/${threadId}?mode=chat`);
    const contextText = ctx.contents[0].text;
    return {
        description: `Thread context for ${weaveId}/${threadId}`,
        messages: [
            {
                role: 'user',
                content: { type: 'text', text: contextText },
            },
            {
                role: 'user',
                content: {
                    type: 'text',
                    text: 'Review this thread and propose the next action. Consider the current design, active plan, and any blocked or incomplete steps.',
                },
            },
        ],
    };
}
